<template>
  <div class="w3-card">
  <div>
    <user-header v-bind:user="convo.meta.creator" />
    
    <div style="padding-bottom: 5px">
      <div v-if="isEditing">
        <input ref="title" type="text" name="title" placeholder="TITLE" v-model="convoForm.title" class="form-control"><br/>
        <textarea-autosize ref="body" rows="3" placeholder="Start a conversation..." v-model="convoForm.body" class="form-control"></textarea-autosize>
        <p>
           &nbsp; <edit-button v-bind:isEditing="true" @done="save()" /> &nbsp; <cancel-button @cancel="cancelEdit()" />
        </p>
      </div>
      <div v-else>
        <p class="w3-theme-dark">
          {{convo.title}} <edit-button v-if="isEditable" v-bind:isEditing="false" @edit="edit()" />
        </p>
        <p class="w3-left-align">{{convo.body}}<br/><br/></p>
      </div>
    </div>

    <div>
      <convo-references v-bind:convo="convo" v-bind:isEditable="isEditable" />
    </div>
    <hr class="w3-clear" style='padding:0px; spacing:0px; margin:0px 0px 10px 0px'>
    <div>
      <convo-tags v-bind:convo="convo" v-bind:isEditable="isEditable" />
    </div>
    <hr class="w3-clear" style='padding:0px; spacing:0px; margin:10px 0px 0px 0px'>
    <div>
      <span v-if="isAuthenticated">
        <endorse-button v-bind:model="convo" @toggleOn="likeConvo()" @toggleOff="unlikeConvo()" />
        <follow-button v-bind:model="convo" @toggleOn="followConvo()" @toggleOff="unfollowConvo()" />
        <copy-button @copy="copyConvo()" v-bind:type="'fal'" v-bind:icon="'comments'"/>
      </span>
      <span v-else>
        <endorse-nonauth-button v-bind:convo="convo" />
        <login-button v-bind:text="'Login to react'" />
      </span>
      <share-button v-bind:type="'convos'" v-bind:id="convo.id" />
    </div>
  </div>

  <div :style="'padding:10px; background-color:' + (convo.meta.isAllJybed?'#c0e0e8':'#f0ccdd')">
    <div>
      &nbsp;<toggle-button v-bind:isHidden="isStatementsHidden" @show="showStatements()" @hide="hideStatements()" />
      <button @click="isStatementsHidden?showStatements():hideStatements()" type="button" class="w3-button" style="margin:0px; padding:0px">
        <span style='font-weight:bold'>&nbsp;Statements: </span>
      </button> 
     <edit-button v-if="isEditable" v-bind:isEditing="false" @edit="editStatements()" />
    </div>
    <convo-statements v-if="!isStatementsHidden" v-bind:convo="convo" />
  </div>
  <br />
  <div style='padding:10px; background-color:#f0f0f0'>
    &nbsp;<toggle-button v-bind:isHidden="isCommentsHidden" @show="showComments()" @hide="hideComments()" />
    <button @click="isCommentsHidden?showComments():hideComments()" type="button" class="w3-button" style="margin:0px; padding:0px">
      <span style='font-weight:bold'>&nbsp;Comments: </span>
    </button> 
    <convo-comments v-if="!isCommentsHidden" v-bind:convo="convo" />
  </div>
  </div>
</template>

<script>
  import ConvoView from "./ConvoView.ts";

  export default ConvoView;
</script>
